import { apiSlice } from "../../app/api/apiSlice";

export const communityApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // fetchReferralSourceById: builder.mutation({
    //   query: (credentials) => ({
    //     url: `/community/${credentials}`,
    //     method: "GET",
    //   }),
    // }),
    createReferralSource: builder.mutation({
      query: (credentials) => ({
        url: `/referral-source/`,
        method: "POST",
        body: credentials,
      }),
    }),
    updateReferralSource: builder.mutation({
      query: (credentials) => ({
        url: `/referral-source/${credentials.id}`,
        method: "PATCH",
        body: credentials,
      }),
    }),
    deleteReferralSource: builder.mutation({
      query: (credentials) => ({
        url: `/referral-source/${credentials?.id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  //   useFetchReferralSourceByIdMutation,
  useCreateReferralSourceMutation,
  useUpdateReferralSourceMutation,
  useDeleteReferralSourceMutation,
} = communityApiSlice;
